module.exports = __webpack_public_path__ + "img/air-freshener.74837376.svg";